import React from "react";
import BuddiesHeaderTab from "./BuddiesHeaderTab";
import BuddiesGroupsSubNavHeaderTab from "./BuddiesGroupsSubNavHeaderTab";

export default function BuddiesGroupHeaderTab(props) {
    return (
        <React.Fragment>
            {!props.activeTabs.students && !props.activeTabs.alumni && !props.activeTabs.staff ? (
                <BuddiesHeaderTab
                    onClick={() => props.onSelectTab("Buddies")}
                    to={`${props.rootUrl}/buddies`}
                />
            ) : (
                <BuddiesGroupsSubNavHeaderTab {...props} />
            )}
        </React.Fragment>
    );
}
